<template>
<div class="group-panel">

    <div class="group-heading" :class="{collapsed: collapsed || !itemCount}" @click="toggleCollapse">
        <div class="group-heading-label">{{groupTitle}}
            <v-icon style="margin-top:-3px" v-if="itemCount && !readOnly" class="collapse-button" :class="{collapsed:collapsed}" small >mdi-chevron-up</v-icon>
        </div>
        <div v-if="!readOnly" class="group-heading-buttons" :class="{collapsed:collapsed}">   
            <div @click.stop="subtract" v-if="itemCount" class="group-heading-button" :class="{collapsed:collapsed}">
                <v-icon  small >mdi-minus</v-icon>
            </div>
            <div @click.stop="add" class="group-heading-button" :class="{collapsed:collapsed}">
                <v-icon small>mdi-plus</v-icon>
            </div>
        </div>
    </div>

    <v-expand-transition>
        <div v-if="schema && !collapsed">

            <!-- Loop items in collection -->
            <draggable :value="value" @input="draggableInput" class="draggable-container" animation="350" group="elements" handle=".menu-handle" :class="{columns:schema.columns, 'read-only': readOnly}">   
                <div v-for="(record, recordIndex) in value" :key="recordIndex" class="group-item-area" :class="{'read-only': readOnly}" :style="columnStyle">
                    
                    <div v-if="!readOnly" style="position:absolute;right:-2px;top:5px;" class="menu-handle">
                        <v-menu offset-y left>
                            <template v-slot:activator="{ on }">
                                <v-icon color="grey lighten-1" v-on="on">more_vert</v-icon>
                            </template>
                            <v-list>
                                <v-list-item @click="deleteItem(recordIndex)">
                                    <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>  
                    </div>

                    <div class="inputs-area">

                            <!-- :schema="schema.fields"  -->
                        <ControlList
                            :horizontal="schema.horizontal"
                            :schema="schemaFields" 
                            :value="record"
                            @change="emitChanges(...arguments, recordIndex)"
                        />

                    </div>

                </div>
            </draggable>
        </div>
    </v-expand-transition>
</div>

</template>

<script>
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import AlertHelpers from '../../helpers/AlertHelpers'
import draggable from 'vuedraggable'

export default {
    data() {
        return {
            collapsed: false,
        }
    },

    components: {
        ConfirmIcon, draggable
    },
    
    props: {
        schema: Object,
        value: {
            type: Array,
            default: function() {
                return []
            },
        } 
    },

    computed: {

        columnStyle() {
            const style = {}
            if(this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px'
            }
            return style
        },

        schemaFields() {
            this.schema.fields.forEach(field => {
                field._root = this.schema._root
            })
            return this.schema.fields
        },

        readOnly() {
            return Boolean(this.schema._root.readOnly)
        },

        groupTitle() {
            const len = this.value ? this.value.length : 0
            if(len == 0)
                return 'No ' + this.schema.label
            else if(len == 1)
                return '1 ' + this.schema.label.replace(/ies$/, 'y').replace(/s$/, '')
            else
                return len + ' ' + this.schema.label
        },

        itemCount() {
            if(this.value)
                return this.value.length
            else
                return 0
        }
   
    },

    methods: {
        emitChanges(newVal, recordIndex) {  
            this.value.splice(recordIndex, 1, newVal)
            this.$emit('change', this.value)
        },
     
        add() {
            
            const schema = this.schema
            const newRecord = {}
            schema.fields.forEach(field =>  {
                if(field.default)
                    newRecord[field.name] = field.default + ' ' + (this.value.length + 1)
            })

            this.value.push(newRecord)
      
            setTimeout(() => {
                const inputs = this.$el.getElementsByTagName('input')
                inputs[0].focus()
                inputs[0].select() 
            }, 300);
     
        },

        subtract() {
            this.value.splice(this.value.length - 1, 1)
        },

        deleteItem(idx) {
            this.value.splice(idx, 1)
            if(!this.itemCount)
                this.collapsed = false
        },
        
        toggleCollapse() {
            if(this.itemCount)
                this.collapsed = !this.collapsed
            else
                this.collapsed = false
        },

        draggableInput(newVal) {
            this.$emit('change', newVal)
        }
    },

    created() {

    }
}
</script>

<style scoped>  

.group-panel {
    border: solid 1px #ddd;
    border-radius:5px;
    margin-bottom:22px;
    background-color:rgba(0,0,0,0.02);
}

.group-heading {
    color: #666;
    background-color:rgba(0,0,0,0.02);   
    position: relative;
    overflow: hidden;
    border-radius: 5px 5px 0 0; 
    user-select: none;
}

.group-heading.collapsed {
    border-radius: 5px 5px 5px 5px; 
}

.group-heading-label {
    display:inline-block;
    padding:  8px 20px;
}

.group-heading-buttons {
    text-align:right;
    position:absolute;
    right:0;
    display:inline-flex;
    transition: right .3s ease-in-out;
}

.group-heading-buttons.collapsed {
    right:-100px;
}

.group-heading-button {
    padding:8px 16px;
    display: inline-block;
    border-left: solid 1px #ddd;
}

.group-heading-button:hover, .group-heading:hover {
    background-color: rgba(0,0,0,0.03);
}

.group-item-area {
    position:relative;
    padding: 22px 20px 0px 20px; 
    border-top: solid 1px #ddd;
}

.group-item-area.read-only {
    position:relative;
    padding: 10px 10px 0px 10px;
}

.group-item-area.columns {
    padding: 10px 20px 10px 10px; 
}

.columns {
    display:flex;flex-wrap:wrap;
}
.columns > .group-item-area {
    flex-grow: 1;
    flex-shrink: 1;
}


.collapse-button {
    transition: transform .5s ease-in-out;
}
.collapse-button.collapsed {
    transform: rotate(180deg);
}


   
</style>



// WEBPACK FOOTER //
// GroupControl.vue?e8535ebc